import editHook from './src/hook';
import { VXETable } from '../v-x-e-table';
export var VxeModuleEdit = {
    install: function () {
        VXETable.hooks.add('$tableEdit', editHook);
    }
};
export var Edit = VxeModuleEdit;
export default VxeModuleEdit;
